export default __webpack_public_path__ + "src/images/packages/emily-moon-lodge/34252c8b1ff4517d5f292474b117e808-1.jpg";